import { css } from 'styled-components'

export const ModalStyles = css`
  :root {
    --modal-background: var(--white);
    --modal-border: 1px solid var(--gray-50);
    --modal-shadow: var(--shadow);
  }
`
